import { request } from 'utils/request';

import * as Types from 'types';
import {
  mapResponseArtworkToArtwork,
  ResponseArtwork,
} from 'features/artworks/api';

export type ResponseWish = {
  id: number;
  artwork: ResponseArtwork;
};

export const mapWishResponseToWish = (wish: ResponseWish): Types.Wish => ({
  id: wish.id,
  artwork: mapResponseArtworkToArtwork(wish.artwork),
});

export const requestWishes = (): Promise<Types.Wish[]> =>
  request
    .get<ResponseWish[]>(`/api/internal/wishes`)
    .then(({ data }) => data.map(mapWishResponseToWish));
